import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { getDistanceFromLatLon } from 'src/app/utils/utils.common';
import { PlannerHelpingService } from './planner-helping-service';

@Injectable({
  providedIn: 'root'
})
export class PlanningAreasWiseService {

  user;
  preData;
  selectedMapper;
  preFleet;
  violation;
  selectedDrivers;
  selectedMethod;
  timeCalibration;
  shiftMapper;

  constructor(private assigTripsService: AssigTripsService,
    private plannerHelpingService: PlannerHelpingService) {
  }

  async planTrips(user, preData, preFleet, violation, selectedMapper, selectedDrivers, selectedMethod,timeCalibration, shiftMapper) {
    this.user = user;
    this.preData = preData;
    this.preFleet = preFleet;
    this.violation = violation;
    this.timeCalibration = timeCalibration;
    this.selectedMapper = selectedMapper;
    this.shiftMapper = shiftMapper
    this.selectedDrivers = selectedDrivers;
    this.selectedMethod = selectedMethod;

    let planedTrips = {
      trips: [],
      nonCompatible: [],
      compatible: {},
      tripLogs: {}
    };

    // convert ids to trip
    for (let trip of this.preData.trips) {
      if (this.preData.selectedTrips.includes(trip._id)) {
        planedTrips.trips.push(trip);
      }
    }


    // if (this.timeCalibration && this.timeCalibration !== "none") {
    //     // set pickup and drop off time
    //     for (let trip of planedTrips.trips) {
    //       const distance = await this.calculateDistance(
    //         trip.jobOriginLatitude,
    //         trip.jobOriginLongitude,
    //         trip.jobDestinationLatitude,
    //         trip.jobDestinationLongitude
    //       );
    //       if (distance && distance.duration) {
    //         if (timeCalibration === "pickup-wise") {
    //           trip.scheduleTime = moment(trip.appointmentTime).tz(user.timeZone).subtract(distance.duration, 'minutes').toISOString();
    //         } else {
    //           trip.appointmentTime = moment(trip.scheduleTime).tz(user.timeZone).add(distance.duration, 'minutes').toISOString();
    //         }
    //       }
    //     }
    //   }

     if (this.timeCalibration && this.timeCalibration !== "none") {
      if (this.timeCalibration === "pickup-wise") {
        await this.plannerHelpingService.applyPickupWiseCalibration(this.selectedMethod, planedTrips.trips, user);
      } else if (this.timeCalibration === "dropoff-wise") {
        await this.plannerHelpingService.applyDropoffWiseCalibration(this.selectedMethod, planedTrips.trips, user);
      } else {
        await this.plannerHelpingService.applyMemberWiseHybridCalibration(this.selectedMethod, planedTrips.trips, user);
      }
    }



    this.selectedDrivers.sort((a, b) =>
      a.displayName.localeCompare(
        b.displayName
      )
    );

    planedTrips.trips.sort((a, b) => {
      return moment(a.scheduleTime).tz(this.user.timeZone).diff(moment(b.scheduleTime).tz(this.user.timeZone));
    });

    for (let driver of this.selectedDrivers) {
      // push all non in to trips for next iteration
      if (planedTrips.nonCompatible.length) {
        planedTrips.trips.push(...planedTrips.nonCompatible);
        planedTrips.nonCompatible = [];
      }


      if (planedTrips.trips.length) {
        const totalDistance = 0;
       await  this.filterTrips(planedTrips, driver, totalDistance);
      } else {
        break;
      }
    }
    //  push all non left trips to nonCompatible show, it will become visible on all screen
    if (planedTrips.trips && planedTrips.trips.length) {
      planedTrips.nonCompatible.push(...planedTrips.trips);
      planedTrips.trips = [];
    }

    console.log(planedTrips);
    return planedTrips;
  }

   async filterTrips(planedTrips, driver, totalDistance) {

    // debugger;
    if (!planedTrips.trips.length) {
      return planedTrips;
    }

    let selectedTrip = JSON.parse(JSON.stringify(planedTrips.trips[0]));
    //remove first trip
    planedTrips.trips.splice(0, 1);

    const checkDistance = await this.calculateDistance(selectedTrip.jobOriginLatitude, selectedTrip.jobOriginLongitude, selectedTrip.jobDestinationLatitude, selectedTrip.jobDestinationLongitude);

    let isCompatible = false;

    // checks shift parameter

    // checks other paramehters
    let logs = {};

    const isFundingSourceWiseExist = this.fundingSourcesWiseTrip(selectedTrip, driver);
    logs = { ...logs, isFundingSourceWiseExist };
    if (isFundingSourceWiseExist) {
      const isDriverShiftWiseExist = this.checkDriverShift(selectedTrip, driver);
      logs = { ...logs, isDriverShiftWiseExist };
      if (isDriverShiftWiseExist) {
        const isServiceAreasWiseExist = this.serviceAreasWiseTrip(selectedTrip, driver);
        logs = { ...logs, isServiceAreasWiseExist };
        if (isServiceAreasWiseExist) {
          const isSpaceTypeWiseExist = this.spaceTypeWiseTrip(selectedTrip, driver);
          logs = { ...logs, isSpaceTypeWiseExist };
          if (isSpaceTypeWiseExist) {
          const isGenderWiseExist = this.genderWiseTrip(selectedTrip, driver);
            logs = { ...logs, isGenderWiseExist };
            if (isGenderWiseExist) {
              const istimeWiseTripExist = await this.timeWiseTrip(planedTrips, selectedTrip, driver, checkDistance.duration);
              logs = { ...logs, istimeWiseTripExist };
              if (istimeWiseTripExist) {
                isCompatible = true;
              }
            }
          }
        }
      }
    }

    // detail trips on base of isCompatible
    if (isCompatible) {
      if (planedTrips.compatible[driver._id]) {
        planedTrips.compatible[driver._id].trips.push(selectedTrip);
      } else {
        planedTrips.compatible[driver._id] = {
          driver,
          trips: [selectedTrip]
        }
      }
      totalDistance += checkDistance.distance;

      // check WNR trip and assign to same driver

      const isWNRExist =  this.isWNRSpaceType(selectedTrip);
      if (isWNRExist) {
        const BTripIndex = planedTrips.trips.findIndex(tr => tr.priorityClient.displayName.toLowerCase() === selectedTrip.priorityClient.displayName.toLowerCase());
        if (BTripIndex !== -1) {
          let newSelectedTrip = JSON.parse(JSON.stringify(planedTrips.trips[BTripIndex]));
          planedTrips.trips.splice(BTripIndex, 1);
          planedTrips.compatible[driver._id].trips.push(newSelectedTrip);
          const newTripDistance = await  this.calculateDistance(newSelectedTrip.jobOriginLatitude, newSelectedTrip.jobOriginLongitude, newSelectedTrip.jobDestinationLatitude, newSelectedTrip.jobDestinationLongitude);
          totalDistance += newTripDistance.distance;
        }
      }

    } else {
      planedTrips.nonCompatible.push(selectedTrip);

      // create Trip logs
      if (planedTrips.tripLogs[driver._id]) {
        planedTrips.tripLogs[driver._id].reasons.push({
          trip: selectedTrip,
          logs
        });
      } else {
        planedTrips.tripLogs[driver._id] = {
          driver,
          reasons: [{
            trip: selectedTrip,
            logs
          }]
        }
      }

    }

    let isMaxFactor = this.checkTripMaxFactor(planedTrips, driver, totalDistance);
    // add trip log even trip is compatible
    if (isCompatible && !isMaxFactor) {

      if (planedTrips.tripLogs[driver._id]) {
        planedTrips.tripLogs[driver._id].reasons.push({
          trip: selectedTrip,
          logs: {...logs, isMaxFactor}
        });
      } else {
        planedTrips.tripLogs[driver._id] = {
          driver,
          reasons: [{
            trip: selectedTrip,
            logs: {...logs, isMaxFactor}
          }]
        }
      }

    }

    if (planedTrips.trips.length && isMaxFactor) {
      await this.filterTrips(planedTrips, driver, totalDistance);
    }

    return planedTrips;
  }

  checkTripMaxFactor(planedTrips, driver, totalDistance) {
    // debugger;
    let isExecute = true;
    // total trips check
    if (this.violation) {
      if (this.violation && this.violation.maxPerRun) {
        if (planedTrips.compatible[driver._id] && planedTrips.compatible[driver._id].trips) {
          if (planedTrips.compatible[driver._id].trips.length >= this.violation.maxPerRun) {
            isExecute = false
          }
        }

      }


      if (this.violation && this.violation.maxDistancePerRun && totalDistance) {
        if (totalDistance >= this.violation.maxDistancePerRun) {
          isExecute = false
        }
      }
    }
    // // debugger;
    return isExecute;
  }

  checkDriverShift(selectedTrip, driver) {
    let isExist = false;
    //Time zone is missing
    const start = moment(this.preData.date).startOf('day');
    const end = moment(this.preData.date).endOf('day');

    if (this.shiftMapper[driver._id].shifts && this.shiftMapper[driver._id].shifts.length) {
      const checkTodayShift = this.shiftMapper[driver._id].shifts.find(item => item.day == start.day() && item.isEnabled);
      if (checkTodayShift && checkTodayShift.checkin) {
        start.set({ hour: checkTodayShift.checkin.split(':')[0], minute: checkTodayShift.checkin.split(':')[1] });
        end.set({ hour: checkTodayShift.checkout.split(':')[0], minute: checkTodayShift.checkout.split(':')[1] });

        if (moment(selectedTrip.scheduleTime).tz(this.user.timeZone).isBetween(start, end)) {
          isExist = true;
        }

      }
    }


    // // debugger;
    return isExist;
  }

  isWNRSpaceType(selectedTrip) {
    let isExist = false;

    if (selectedTrip.spaceType && this.preData.spaceTypes[selectedTrip.spaceType] && this.preData.spaceTypes[selectedTrip.spaceType].wnr) {
      isExist = true;
    }

    return isExist;
  }

  fundingSourcesWiseTrip(selectedTrip, driver) {
    // debugger;
    let isExist = false;
    const isfundingSource = driver.fundingSources.some(d => d.name === selectedTrip.cooperate && moment(this.preData.date).isBetween(moment(d.validityRange[0]).tz(this.user.timeZone).subtract(1,'day'), moment(d.validityRange[1]).tz(this.user.timeZone).add(1,'day')));
    if (selectedTrip.cooperate && isfundingSource) {
      const driverFleetId = this.selectedMapper.mappers[driver._id];
      if (driverFleetId) {
        // // debugger;
        if (this.preFleet[driverFleetId].fundingSources && this.preFleet[driverFleetId].fundingSources.includes(selectedTrip.cooperate)) {
          isExist = true;
        }
      }
    }
    // // debugger;
    return isExist;
  }

  serviceAreasWiseTrip(selectedTrip, driver) {
    // // debugger;
    let isExist = false;
    if (selectedTrip.serviceArea && this.shiftMapper[driver._id] && this.shiftMapper[driver._id].serviceAreas.includes(selectedTrip.serviceArea)) {
      isExist = true;
    }
    // // debugger;
    return isExist;
  }

  spaceTypeWiseTrip(selectedTrip, driver) {
    // debugger;
    let isExist = false;

    if (this.violation && !this.violation.isCapacityViolation) {
      const driverFleetId = this.selectedMapper.mappers[driver._id];
      if (driverFleetId) {
        if (selectedTrip.spaceType && driverFleetId) {
          isExist = this.preFleet[driverFleetId].capacities.some(capacity => capacity.spaceType === selectedTrip.spaceType);
        }
      }
    } else {
      isExist = true;
    }
    // // debugger;
    return isExist;
  }

    genderWiseTrip(selectedTrip, driver) {
    let isExist = true;

    if (selectedTrip.priorityClient.isPrefferedFemale) {
      isExist = driver.gender.toLowerCase() === 'female'
    }

    if (selectedTrip.preferredDriver) {
      isExist = driver._id === selectedTrip.priorityClient.preferredDriver;
    }
    return isExist;

  }

  async timeWiseTrip(planedTrips, selectedTrip, driver, duration) {
    //  // debugger;
    let isExist = false;
    const selectedDriverTrips = planedTrips.compatible[driver._id];
    if (selectedDriverTrips === undefined || !selectedDriverTrips.trips.length) {
      isExist = true;
    } else {
      //check currenttrip is after last trip
      const lastTrip = selectedDriverTrips.trips[selectedDriverTrips.trips.length - 1];
      const newPreviousApptTime = moment(lastTrip.appointmentTime).tz(this.user.timeZone);

      if (this.preData.spaceTypes[lastTrip.spaceType]) {

        let loadTime = this.preData.spaceTypes[lastTrip.spaceType].loadTime;
        let unloadTime = this.preData.spaceTypes[lastTrip.spaceType].unloadTime;

        // if (loadTime) {
        //   loadTime = unloadTime.split(':');
        //   newAppointmentTime.add(loadTime[1], 'minutes').add(loadTime[0], 'hours');
        // }

        if (unloadTime) {
          unloadTime = unloadTime.split(':');
          newPreviousApptTime.add(unloadTime[1], 'minutes').add(unloadTime[0], 'hours');
        }
      }
     if (this.violation) {
      //  Add break Cushion
      if (this.violation.breakCushion) {
        newPreviousApptTime.add(this.violation.breakCushion, 'minutes');
      }


      // if (moment(selectedTrip.scheduleTime).isAfter(newAppointmentTime)) {
      //   isExist = true;
      // }


        let pickupEarly = moment(selectedTrip.scheduleTime).tz(this.user.timeZone).subtract(this.violation.pickupEarly, 'minutes');
        let pickupLate = moment(selectedTrip.scheduleTime).tz(this.user.timeZone).add(this.violation.pickupLate, 'minutes');

        let dropoffEarly = moment(newPreviousApptTime).tz(this.user.timeZone).subtract(this.violation.dropoffEarly, 'minutes');
        let dropoffLate = moment(newPreviousApptTime).tz(this.user.timeZone).add(this.violation.dropoffLate, 'minutes');

        if (moment(selectedTrip.scheduleTime).tz(this.user.timeZone).isAfter(newPreviousApptTime)) {
          isExist = true;
        } else if (pickupLate.isAfter(newPreviousApptTime)) {
          isExist = true;
        }

        // check onboard Time of Trip
        if (isExist && !this.violation.isOnboardViolation) {
          if (this.violation.maxOnBoardTime) {
            const travelTime = duration;
            if (travelTime <= this.violation.maxOnBoardTime) {
              isExist = true;
            } else {
              isExist = false;
            }
          }
        }

        if (isExist) {
          // check reach possibility
          const checkpossibleDistance = await this.calculateDistance(lastTrip.jobDestinationLatitude, lastTrip.jobDestinationLongitude, selectedTrip.jobOriginLatitude, selectedTrip.jobOriginLongitude);

          const newTravelTime = checkpossibleDistance.duration;

          newPreviousApptTime.add(newTravelTime, 'minutes');

          if (moment(selectedTrip.scheduleTime).tz(this.user.timeZone).isAfter(newPreviousApptTime)) {
            isExist = true;
          } else if (pickupLate.isAfter(newPreviousApptTime)) {
            isExist = true;
          } else {
            isExist = false;
          }
        }

      } else {
        isExist = true;
      }

    }
    // // debugger;
    return isExist;
  }

 async calculateDistance(lat1, lon1, lat2, lon2) {
    let resutl;
    if (this.selectedMethod && this.selectedMethod === true) {
      resutl = await this.calculateDistanceWithGIS(lat1, lon1, lat2, lon2);
    } else {
      resutl = await new Promise((resolve) => { resolve(getDistanceFromLatLon(lat1, lon1, lat2, lon2))});
    }
    return resutl;
  }


  async calculateDistanceWithGIS(lat1, lon1, lat2, lon2) {
    const res: any = await this.assigTripsService.getRoutingDistance(lat1, lon1, lat2, lon2).toPromise();
    const segments: any = res.features[0].properties.segments;
    return {
      distance: (segments[0].distance / 1609),
      duration: (segments[0].duration / 60)
    };
  }


}

